<template>
  <v-dialog
    :persistent="true"
    :value="value"
    max-width="50rem"
    @input="val => $emit('input', val)">
    <v-card>
      <v-card-text>
        <v-form v-model="valid">
          <v-container grid-list-md>
            <v-layout>
              <v-flex>
                <v-text-field
                  v-model="editedJob.name"
                  :rules="[v => !!v || 'Name is required']"
                  label="Name"/>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-autocomplete
                  :filter="franchisesFilter"
                  :items="franchises"
                  :loading="loadingFranchises"
                  v-model="editedJob.franchise.id"
                  item-text="name"
                  item-value="id"
                  label="Appointed franchise">
                  <template
                    slot="item"
                    slot-scope="data">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{ data.item.name }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action-text v-if="data.item.subcontractor">
                      {{ data.item.subcontractor.name }}
                    </v-list-tile-action-text>
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout align-baseline>
              <v-flex>
                <v-slider
                  v-model="editedJob.rating"
                  :always-dirty="!ratingIsNull"
                  max="5"
                  min="0"
                  label="Rating"
                  ticks
                  thumb-label
                  @start="ratingIsNull = false"/>
              </v-flex>
              <v-btn
                class="ma-0"
                flat
                small
                @click="ratingIsNull = true; editedJob.rating = 0;">
                Reset
              </v-btn>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="posting"
          flat
          @click="$emit('input', false)">
          Cancel
        </v-btn>
        <v-btn
          :disabled="posting || !valid"
          flat
          @click="save">
          <v-progress-circular
            v-if="posting"
            indeterminate/>
          <span v-else>Save</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "edit-dialog",
  props: {
    // Initial job object will be copied when dialog opens up (see watch)
    job: {
      required: true,
      type: Object
    },
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      // Buffered job object while editing
      editedJob: {
        franchise: {},
        issue: {},
        name: "",
        rating: null
      },
      // Known franchises to the DB
      franchises: [],
      loadingFranchises: false,
      posting: false,
      ratingIsNull: false,
      valid: false
    };
  },
  watch: {
    value (open) {
      if (open) {
        this.ratingIsNull = this.job.rating === null;
        this.editedJob = {
          franchise: this.job.franchise
            ? Object.assign({}, this.job.franchise) : {},
          name: this.job.name,
          rating: this.job.rating
        };
      }
    }
  },
  created () {
    // Get the franchises
    this.loadingFranchises = true;
    this.$http.
      get("/api/franchises").
      then((r) => {
        this.loadingFranchises = false;
        this.franchises = Array.from(r.data);
      }).
      catch(() => this.loadingFranchises = false);
  },
  methods: {
    franchisesFilter (item, query) {
      // Case insensitive filter on id
      let q = query ? query : "";
      let h = item.name;
      return h.indexOf(q.toLowerCase()) > -1;
    },
    // When the SAVE button of the edition dialog is clicked
    save () {
      this.posting = true;
      this.$http.
        put(`/api/jobs/${this.job.id}`, {
          franchiseId: this.editedJob.franchise.id,
          name: this.editedJob.name,
          rating: this.ratingIsNull ? null : this.editedJob.rating
        }).
        then(() => this.$http.get(`/api/jobs/${this.job.id}`)).
        then((r) => {
          this.$emit("input", false);
          Object.assign(this.job, r.data);
        }).
        finally(() => this.posting = false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Job/EditDialog.vue